<template>
  <div class="background" id="background">
  <div class="chart-container" id="chart-container">
    <div v-html="styleText"></div>
    <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <img src="../../assets/LOGO.png">
      </div>
      <div class="main-header-right">
        <p>{{$t('Alerts Report')}}</p>
        <p>{{$t('period')}}: &nbsp; {{days}}</p>
      </div>
    </div>

    <!--<table class="status-table1" :class="{'zh1':!isEn,'de1':isDe||isIt||isFr}">-->
    <table class="status-table1">
      <tr>
        <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
        <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
      </tr>
      <tr>
        <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
        <td class="td2" id="reportPdmTitle">{{$t('pdm')}}</td>
        <td colspan="8" class="td3">{{devices[0]}}</td>
      </tr>
      <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{devices[1]}}</td></tr>
      <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{devices[2]}}</td></tr>
      <tr>
        <td class="td1 td4">{{$t('disType')}}</td>
        <td colspan="9" class="x_td4">{{statics.medical_history}}</td>
        <!--<td class="td td4">{{$t('HbA1c')}}</td>
        <td colspan="4">{{hb1c[0]}}</td>-->
      </tr>
    </table>
    <div class="small-hr"></div>

    <div v-show="!haveData" class="no-data">
      No Data
    </div>
    <div v-show="haveData">
      <div v-for="(base, p) in pagePos">
        <div v-if="p>=1">
          <div class="page-seperator"></div>
          <div class="page-starter">
            <!--<br/><br/><br/><br/>-->
          </div>
        </div>

        <table class="alert-table-header">
          <tr>
            <!-- event_Time -->
            <td width="30%">{{$t('time')}}</td>
            <td width="20%">{{$t('type')}}</td>
            <td>{{$t('Alert')}}</td>
          </tr>
        </table>

        <table class="alert-table" v-for="(item, index) in alerts.slice(base, base+perPage[p])" :id="'tbl'+base+index">
          <tr :class="(index%2===0) ? '':'x_even'">
            <td width="30%">{{item[0]}}</td>
            <td width="20%">{{item[3]}}</td>
            <td>{{item[1]}}</td>
          </tr>
        </table>
      </div>
    </div>

    <div v-if="chartEndPage.show">
      <div class="page-seperator"></div>
      <div class="page-starter">
        <!--<br/><br/><br/><br/>-->
      </div>
    </div>


    <div class="page-end"></div>
  </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
  import format from '@/lib/format'
  export default{
    data() {
      return {
        uid: 0, st: 0, et: 0,days:'',dayNum:0,isEn:false,
        statics: {}, hb1c: '--', devices:['--','--','--'],
        pagePos:[],perPage:[],chartEndPage:{show:false},
        whichDate:[],alerts:[],haveData:true,
        styleText:'<style type="text/css" media="print">@page{size:portrait;margin:0;}</style>',

      }
    },
    methods:{
      getReportData(){
        if(sessionStorage.getItem('userType')!=='P'){
          this.uid = parseInt(sessionStorage.getItem('patientId'));
        }else{
          this.uid = parseInt(sessionStorage.getItem('uid'));
        }
        this.ts =auth.getTs(this.st,this.et);
        //console.log(this.ts);
        let param = {
          ts:this.ts,
          tz:parseInt(sessionStorage.getItem('tz')),
          gu:(this.isMg)?'mg/dL':'mmol/L',
        };
        param = B64.base64encode(JSON.stringify(param));
        let context=this;
        //this.statics.username='123';
        this.$http.get('api/v2.1/report/'+this.uid+'/data/alert',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            let data =  res.data.data;
            console.log("alert report data:", data);
            context.statics=data;
            context.devices = (data.devices)?data.devices:context.devices;

            if ('EasyPatch'==context.devices[0]) {
              document.getElementById('reportPdmTitle').innerHTML='APP';
            }
            //console.log('statics:', context.statics);
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },

      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title = this.$t('EventReport');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      //
      //  用新的日期格式
      let st9=sessionStorage.getItem('st9');
      let et9=sessionStorage.getItem('et9');
      let t1=parseInt(st9);
      let t2=parseInt(et9);

      //
      this.st=t1;
      this.et=t2;

      this.getReportData();
      //this.statics.username='13a';
      this.days = format.formatterDate2(t1)+' - '+format.formatterDate2(t2);

      //
      try{
        let alertData=sessionStorage.getItem('alert-data');
        alertData=JSON.parse(alertData);
        console.log('alertData:', alertData);
        this.alerts=alertData.alerts;
        if (0==this.alerts.length) {
          this.haveData=false;
        } else {
          this.haveData=true;
        }

        if (false) {  // 测试数据
          //let item=this.alerts.slice(0,1)[0];
          let item=[
            format.formatterDate2(new Date().getTime()/1000),
            "AAA",
            8601,
            "CGM"
          ];

          console.log('alert test:', item);
          for (let i=0; i<100; i++) {
            let temp=item.slice(0, item.length);
            temp[1]=temp[1]+'#'+(i+1);
            this.alerts.push(temp);
          }
          this.haveData=true;
        }
      } catch (e) {
        console.log('alert error:', e);
      }

      let page_index=0;
      let PER_PAGE1=22;
      let PER_PAGE2=26;
      while (page_index < this.alerts.length) {
        this.pagePos.push(page_index);
        if (1==this.pagePos.length) {
          page_index += PER_PAGE1;
          this.perPage.push(PER_PAGE1);
        } else {
          page_index += PER_PAGE2;
          this.perPage.push(PER_PAGE2);
        }
      }

      //this.pagePos.push(0);
      //this.perPage.push(40);

      //
      //setTimeout(auth._printPdf(),2000);
    },
  }
</script>

<style scoped meadia="print">
  /*@page{
    *size:auto;
    size:landscape;
    margin: 0;
  }*/
  .background{
    padding-top: 5mm;
    width: 100%;
    *min-height: 290mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:210mm;
    min-height:290mm;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .long{
    *min-height: 634mm;
  }
  .longCont{
    *height: 624mm;
  }
  @media screen and (max-width: 1450px){
    .background .noPrint{
      position: absolute;
      left: 20%;
      top: -1px;
    }
    .chart-container{
      margin-top: 20px;
    }
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:13px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }

  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
    font-size:12px;
  }
  .status-table1 td{
    padding-left: 8px;
    height:15px;
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }

  .events-table{
    width: 94%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .events-table td{
    height: 16px;
    font-size: 12px;
    -webkit-transform: scale(0.8);
    -moz-transform: scale(0.8);
    -ms-transform: scale(0.8);
    -o-transform: scale(0.8);
    transform: scale(0.8);
  }
  .events-table .td1{
    border-left:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .events-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-top:1px solid rgba(116,116,116,0.34);
    font-size: 12px;
    -webkit-transform: scale(0.8);
    -moz-transform: scale(0.8);
    -ms-transform: scale(0.8);
    -o-transform: scale(0.8);
    transform: scale(0.8);
    color:#282828;
  }
  .events-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .events-table .td4{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .events-table .td5{
    border:1px solid rgba(116,116,116,0.34);
  }
  .events-table .spe1{
    width: 70px;
  }
  .events-table .spe2{
    width: 50px;
  }

  .statics{
    margin-top: 25px;
    margin-bottom: 17px;
  }
  .statics p{
    margin-left: 3%;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.27px;
    text-align:left;
    padding-left: 3px;
  }
  .statics-table{
    width: 94%;
    margin:6px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .statics-table td{
    height:20px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  .page-seperator {
    *height:20mm;
    page-break-before: always;
  }

  .page-starter {
    height:10mm;
  }

  .page-end {
    clear: both;
    height:1mm;
  }

  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    font-size:12px;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
  }
  .status-table1 td{
    padding-left: 8px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh1 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .status-table1 .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  /*表格*/
  table{
    width:94%;
    border-collapse: collapse;
    margin:0 auto;
  }

  .no-data {
    width:94%;
    margin:0 auto;
    font-size:18px;
  }

  .alert-table-header tr{
    color:#005dac;
    height:45px;
    background:#cfdff0;
    font-size:18px;
    text-align:center;
  }

  .alert-table tr{
    *color:#005dac;
    height:40px;
    *background:#cfdff0;
    font-size:18px;
    text-align:center;
  }

  .even{
    background:#ebeef1;
  }

</style>






// WEBPACK FOOTER //
// alerts_print.vue?06911918